<div [ngClass]="['loading-carregando-mais']">
	<div [ngClass]="['loading-carregando-mais-inner', animation]">
		<mat-spinner [diameter]="32" [color]="'accent'" strokeWidth="4">
		</mat-spinner>
	</div>
</div>